import types from './types';

const download = (api, fileId) => ({
  type: types.DOWNLOAD_FILE,
  params: {
  	api,
		fileId
  }
});

const downloadAsBA = (api, fileId, thumbnail) => ({
  type: types.DOWNLOAD_FILE_AS_BA,
  params: {
		api,
    fileId,
		thumbnail
  }
});

export default {
  download,
  downloadAsBA
};
